import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "admin-pricing" }
const _hoisted_2 = { class: "hero-section" }
const _hoisted_3 = { class: "hero-content" }
const _hoisted_4 = { class: "hero-badge" }
const _hoisted_5 = { class: "hero-decoration" }
const _hoisted_6 = { class: "floating-card card-1" }
const _hoisted_7 = { class: "floating-card card-2" }
const _hoisted_8 = { class: "floating-card card-3" }
const _hoisted_9 = { class: "pricing-section" }
const _hoisted_10 = { class: "billing-toggle" }
const _hoisted_11 = { class: "pricing-cards" }
const _hoisted_12 = { class: "card-price" }
const _hoisted_13 = { class: "price-wrapper" }
const _hoisted_14 = { class: "amount" }
const _hoisted_15 = {
  key: 0,
  class: "price-note"
}
const _hoisted_16 = {
  key: 1,
  class: "price-note"
}
const _hoisted_17 = { class: "tax-note" }
const _hoisted_18 = { class: "card-features" }
const _hoisted_19 = { class: "feature-group" }
const _hoisted_20 = { class: "feature-title" }
const _hoisted_21 = { class: "feature-list" }
const _hoisted_22 = { class: "feature-group" }
const _hoisted_23 = { class: "feature-title" }
const _hoisted_24 = { class: "feature-list" }
const _hoisted_25 = { class: "feature-group" }
const _hoisted_26 = { class: "feature-title" }
const _hoisted_27 = { class: "feature-list" }
const _hoisted_28 = { class: "feature-group" }
const _hoisted_29 = { class: "feature-title" }
const _hoisted_30 = { class: "feature-list" }
const _hoisted_31 = { class: "services-section" }
const _hoisted_32 = { class: "services-grid" }
const _hoisted_33 = { class: "service-title" }
const _hoisted_34 = { class: "service-description" }
const _hoisted_35 = { class: "service-features" }
const _hoisted_36 = { class: "faq-section" }
const _hoisted_37 = { class: "cta-section" }
const _hoisted_38 = { class: "cta-content" }
const _hoisted_39 = { class: "cta-buttons" }

import { ref, computed } from 'vue';

// 결제 주기 상태
const monthlyPrice = 100000;
const annualDiscount = 0.1;


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminPricing',
  setup(__props) {

const isAnnual = ref(false);
const billingCycle = computed(() => isAnnual.value ? 'annual' : 'monthly');

// 가격 계산
const formattedPrice = computed(() => {
  const price = isAnnual.value ? monthlyPrice * (1 - annualDiscount) : monthlyPrice;
  return price.toLocaleString('ko-KR');
});

const formattedAnnualTotal = computed(() => {
  const total = monthlyPrice * 12 * (1 - annualDiscount);
  return `₩${total.toLocaleString('ko-KR')}`;
});

// 서비스 정보
const services = ref([
  {
    title: '임금 관리',
    icon: 'mdi-cash-register',
    iconColor: '#fff',
    gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    description: '복잡한 급여 계산을 자동화하여 정확하고 빠르게 처리합니다.',
    features: [
      '근무시간 기반 자동 급여계산',
      '4대보험 자동 공제 계산',
      '급여명세서 자동 생성 및 발송',
      '연차/휴가 관리'
    ]
  },
  {
    title: '회계 관리',
    icon: 'mdi-calculator-variant',
    iconColor: '#fff',
    gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
    description: '입출금부터 재무제표까지 체계적인 회계 관리를 지원합니다.',
    features: [
      '입출금 내역 자동 분류',
      '예산 편성 및 집행 관리',
      '재무제표 자동 생성',
      '월별/연별 리포트'
    ]
  },
  {
    title: '요양보호사 앱',
    icon: 'mdi-account-heart',
    iconColor: '#fff',
    gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
    description: '요양보호사가 언제 어디서나 필요한 정보를 확인할 수 있습니다.',
    features: [
      '모바일 근무 일정 확인',
      '급여명세서 즉시 조회',
      '공지사항 푸시 알림',
      '근로계약서 열람'
    ]
  },
  {
    title: '보호자 앱',
    icon: 'mdi-account-child',
    iconColor: '#fff',
    gradient: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
    description: '보호자에게 투명한 케어 정보를 제공하여 신뢰를 높입니다.',
    features: [
      '실시간 케어 일지 확인',
      '일정 및 알림 수신',
      '시설 공지사항 확인',
      '담당자 직접 연락'
    ]
  }
]);

// FAQ
const faqs = ref([
  {
    question: '결제는 어떻게 진행되나요?',
    answer: '신용카드, 계좌이체, 자동이체 등 다양한 결제 방식을 지원합니다. 구독 시작 후 매월 동일한 날짜에 자동 결제가 이루어집니다.'
  },
  {
    question: '연간 결제의 할인은 어떻게 적용되나요?',
    answer: '연간 결제 선택 시 월 구독료의 10%가 할인되어, 월 90,000원(부가세 별도)으로 이용하실 수 있습니다. 연간 총 1,080,000원(부가세 별도)이 결제됩니다.'
  },
  {
    question: '구독 취소는 언제든 가능한가요?',
    answer: '네, 언제든지 구독을 취소하실 수 있습니다. 취소 후에도 결제 기간 만료일까지는 모든 기능을 정상적으로 이용하실 수 있습니다.'
  },
  {
    question: '추가 요금이 발생하나요?',
    answer: '기본 구독료 외에 추가 요금은 발생하지 않습니다. 요양보호사 앱, 보호자 앱 모두 기본 구독에 포함되어 있습니다.'
  },
  {
    question: '데이터 이전 서비스를 제공하나요?',
    answer: '기존 시스템에서 사용하던 데이터 이전을 무료로 지원해드립니다. 담당자가 직접 도와드리니 문의해 주세요.'
  }
]);

// 구독 버튼 핸들러
const handleSubscribe = () => {
  // 구독 프로세스 시작 (추후 구현)
  console.log('구독 시작:', billingCycle.value);
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_icon, { size: "16" }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("mdi-star", -1)
            ]))]),
            _: 1
          }),
          _cache[2] || (_cache[2] = _createElementVNode("span", null, "요양기관 맞춤 솔루션", -1))
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "hero-title" }, [
          _createTextVNode(" 요양원 운영의 "),
          _createElementVNode("span", { class: "highlight" }, "모든 것"),
          _createTextVNode("을"),
          _createElementVNode("br"),
          _createTextVNode(" 하나로 통합하세요 ")
        ], -1)),
        _cache[4] || (_cache[4] = _createElementVNode("p", { class: "hero-description" }, [
          _createTextVNode(" 임금관리부터 회계, 요양보호사 앱까지"),
          _createElementVNode("br"),
          _createTextVNode(" 복잡한 업무를 간편하게 관리하는 통합 솔루션 ")
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_v_icon, { color: "success" }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("mdi-check-circle", -1)
            ]))]),
            _: 1
          }),
          _cache[6] || (_cache[6] = _createElementVNode("span", null, "자동 급여계산", -1))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_v_icon, { color: "primary" }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode("mdi-cellphone", -1)
            ]))]),
            _: 1
          }),
          _cache[8] || (_cache[8] = _createElementVNode("span", null, "모바일 앱 지원", -1))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_v_icon, { color: "warning" }, {
            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
              _createTextVNode("mdi-chart-line", -1)
            ]))]),
            _: 1
          }),
          _cache[10] || (_cache[10] = _createElementVNode("span", null, "실시간 리포트", -1))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_9, [
      _cache[61] || (_cache[61] = _createElementVNode("div", { class: "section-header" }, [
        _createElementVNode("h2", { class: "section-title" }, "심플한 가격 정책"),
        _createElementVNode("p", { class: "section-subtitle" }, "필요한 모든 기능을 합리적인 가격에")
      ], -1)),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("span", {
          class: _normalizeClass({ active: billingCycle.value === 'monthly' })
        }, "월간 결제", 2),
        _createVNode(_component_v_switch, {
          modelValue: isAnnual.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isAnnual).value = $event)),
          color: "primary",
          "hide-details": "",
          density: "compact",
          inset: ""
        }, null, 8, ["modelValue"]),
        _createElementVNode("span", {
          class: _normalizeClass({ active: billingCycle.value === 'annual' })
        }, [
          _cache[12] || (_cache[12] = _createTextVNode(" 연간 결제 ", -1)),
          _createVNode(_component_v_chip, {
            color: "success",
            size: "x-small",
            variant: "flat",
            class: "ml-1"
          }, {
            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
              _createTextVNode("10% 할인", -1)
            ]))]),
            _: 1
          })
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_v_card, {
          class: "pricing-card premium",
          elevation: "8"
        }, {
          default: _withCtx(() => [
            _cache[59] || (_cache[59] = _createElementVNode("div", { class: "card-ribbon" }, [
              _createElementVNode("span", null, "BEST")
            ], -1)),
            _cache[60] || (_cache[60] = _createElementVNode("div", { class: "card-header" }, [
              _createElementVNode("div", { class: "plan-name" }, "프리미엄 플랜"),
              _createElementVNode("div", { class: "plan-tagline" }, "모든 기능을 제한 없이")
            ], -1)),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[13] || (_cache[13] = _createElementVNode("span", { class: "currency" }, "₩", -1)),
                _createElementVNode("span", _hoisted_14, _toDisplayString(formattedPrice.value), 1),
                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "period" }, "/월", -1))
              ]),
              (isAnnual.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, " 연간 결제 시 " + _toDisplayString(formattedAnnualTotal.value) + " (10% 할인 적용) ", 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_16, " 연간 결제 시 10% 할인 적용 ")),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_v_icon, {
                  size: "14",
                  class: "mr-1"
                }, {
                  default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                    _createTextVNode("mdi-information-outline", -1)
                  ]))]),
                  _: 1
                }),
                _cache[16] || (_cache[16] = _createTextVNode(" 부가세 별도 ", -1))
              ])
            ]),
            _createVNode(_component_v_divider, { class: "my-4" }),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_v_icon, {
                    color: "primary",
                    size: "20"
                  }, {
                    default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                      _createTextVNode("mdi-cash-register", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[18] || (_cache[18] = _createTextVNode(" 임금 관리 ", -1))
                ]),
                _createElementVNode("ul", _hoisted_21, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_v_icon, {
                      color: "success",
                      size: "16"
                    }, {
                      default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                        _createTextVNode("mdi-check", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[20] || (_cache[20] = _createTextVNode(" 자동 급여 계산", -1))
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_v_icon, {
                      color: "success",
                      size: "16"
                    }, {
                      default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                        _createTextVNode("mdi-check", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[22] || (_cache[22] = _createTextVNode(" 4대보험 자동 산출", -1))
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_v_icon, {
                      color: "success",
                      size: "16"
                    }, {
                      default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                        _createTextVNode("mdi-check", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[24] || (_cache[24] = _createTextVNode(" 급여명세서 자동 발송", -1))
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_v_icon, {
                      color: "success",
                      size: "16"
                    }, {
                      default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                        _createTextVNode("mdi-check", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[26] || (_cache[26] = _createTextVNode(" 근로계약서 관리", -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_v_icon, {
                    color: "primary",
                    size: "20"
                  }, {
                    default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                      _createTextVNode("mdi-calculator-variant", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[28] || (_cache[28] = _createTextVNode(" 회계 관리 ", -1))
                ]),
                _createElementVNode("ul", _hoisted_24, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_v_icon, {
                      color: "success",
                      size: "16"
                    }, {
                      default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                        _createTextVNode("mdi-check", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[30] || (_cache[30] = _createTextVNode(" 입출금 내역 관리", -1))
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_v_icon, {
                      color: "success",
                      size: "16"
                    }, {
                      default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                        _createTextVNode("mdi-check", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[32] || (_cache[32] = _createTextVNode(" 예산 편성 및 관리", -1))
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_v_icon, {
                      color: "success",
                      size: "16"
                    }, {
                      default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                        _createTextVNode("mdi-check", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[34] || (_cache[34] = _createTextVNode(" 재무제표 자동 생성", -1))
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_v_icon, {
                      color: "success",
                      size: "16"
                    }, {
                      default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                        _createTextVNode("mdi-check", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[36] || (_cache[36] = _createTextVNode(" 수입자료 분석", -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_v_icon, {
                    color: "primary",
                    size: "20"
                  }, {
                    default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                      _createTextVNode("mdi-account-heart", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[38] || (_cache[38] = _createTextVNode(" 요양보호사 앱 ", -1))
                ]),
                _createElementVNode("ul", _hoisted_27, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_v_icon, {
                      color: "success",
                      size: "16"
                    }, {
                      default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                        _createTextVNode("mdi-check", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[40] || (_cache[40] = _createTextVNode(" 근무 일정 확인", -1))
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_v_icon, {
                      color: "success",
                      size: "16"
                    }, {
                      default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                        _createTextVNode("mdi-check", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[42] || (_cache[42] = _createTextVNode(" 급여명세서 조회", -1))
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_v_icon, {
                      color: "success",
                      size: "16"
                    }, {
                      default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                        _createTextVNode("mdi-check", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[44] || (_cache[44] = _createTextVNode(" 공지사항 알림", -1))
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_v_icon, {
                      color: "success",
                      size: "16"
                    }, {
                      default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                        _createTextVNode("mdi-check", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[46] || (_cache[46] = _createTextVNode(" 문서 열람", -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_v_icon, {
                    color: "primary",
                    size: "20"
                  }, {
                    default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                      _createTextVNode("mdi-account-child", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[48] || (_cache[48] = _createTextVNode(" 보호자 앱 ", -1))
                ]),
                _createElementVNode("ul", _hoisted_30, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_v_icon, {
                      color: "success",
                      size: "16"
                    }, {
                      default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                        _createTextVNode("mdi-check", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[50] || (_cache[50] = _createTextVNode(" 케어 일지 확인", -1))
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_v_icon, {
                      color: "success",
                      size: "16"
                    }, {
                      default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                        _createTextVNode("mdi-check", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[52] || (_cache[52] = _createTextVNode(" 일정 알림 수신", -1))
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_v_icon, {
                      color: "success",
                      size: "16"
                    }, {
                      default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                        _createTextVNode("mdi-check", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[54] || (_cache[54] = _createTextVNode(" 시설 공지 확인", -1))
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_v_icon, {
                      color: "success",
                      size: "16"
                    }, {
                      default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                        _createTextVNode("mdi-check", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[56] || (_cache[56] = _createTextVNode(" 담당자 연락", -1))
                  ])
                ])
              ])
            ]),
            _createVNode(_component_v_btn, {
              color: "primary",
              size: "large",
              block: "",
              class: "subscribe-btn",
              onClick: handleSubscribe
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { start: "" }, {
                  default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                    _createTextVNode("mdi-rocket-launch", -1)
                  ]))]),
                  _: 1
                }),
                _cache[58] || (_cache[58] = _createTextVNode(" 지금 시작하기 ", -1))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("section", _hoisted_31, [
      _cache[63] || (_cache[63] = _createElementVNode("div", { class: "section-header" }, [
        _createElementVNode("h2", { class: "section-title" }, "포함된 서비스"),
        _createElementVNode("p", { class: "section-subtitle" }, "요양원 운영에 필요한 모든 기능을 한곳에서")
      ], -1)),
      _createElementVNode("div", _hoisted_32, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(services.value, (service) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "service-card",
            key: service.title
          }, [
            _createElementVNode("div", {
              class: "service-icon",
              style: _normalizeStyle({ background: service.gradient })
            }, [
              _createVNode(_component_v_icon, {
                color: service.iconColor,
                size: "32"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(service.icon), 1)
                ]),
                _: 2
              }, 1032, ["color"])
            ], 4),
            _createElementVNode("h3", _hoisted_33, _toDisplayString(service.title), 1),
            _createElementVNode("p", _hoisted_34, _toDisplayString(service.description), 1),
            _createElementVNode("ul", _hoisted_35, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(service.features, (feature) => {
                return (_openBlock(), _createElementBlock("li", { key: feature }, [
                  _createVNode(_component_v_icon, {
                    color: "success",
                    size: "14"
                  }, {
                    default: _withCtx(() => [...(_cache[62] || (_cache[62] = [
                      _createTextVNode("mdi-check-circle", -1)
                    ]))]),
                    _: 1
                  }),
                  _createTextVNode(" " + _toDisplayString(feature), 1)
                ]))
              }), 128))
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_36, [
      _cache[65] || (_cache[65] = _createElementVNode("div", { class: "section-header" }, [
        _createElementVNode("h2", { class: "section-title" }, "자주 묻는 질문")
      ], -1)),
      _createVNode(_component_v_expansion_panels, {
        variant: "accordion",
        class: "faq-panels"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(faqs.value, (faq, index) => {
            return (_openBlock(), _createBlock(_component_v_expansion_panel, { key: index }, {
              default: _withCtx(() => [
                _createVNode(_component_v_expansion_panel_title, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      color: "primary",
                      class: "mr-3"
                    }, {
                      default: _withCtx(() => [...(_cache[64] || (_cache[64] = [
                        _createTextVNode("mdi-help-circle", -1)
                      ]))]),
                      _: 1
                    }),
                    _createTextVNode(" " + _toDisplayString(faq.question), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_v_expansion_panel_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(faq.answer), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("section", _hoisted_37, [
      _createElementVNode("div", _hoisted_38, [
        _cache[70] || (_cache[70] = _createElementVNode("h2", { class: "cta-title" }, "지금 바로 시작하세요", -1)),
        _cache[71] || (_cache[71] = _createElementVNode("p", { class: "cta-description" }, " 복잡한 요양원 운영, CAION과 함께라면 쉬워집니다 ", -1)),
        _createElementVNode("div", _hoisted_39, [
          _createVNode(_component_v_btn, {
            color: "white",
            size: "large",
            variant: "flat",
            class: "cta-btn-primary",
            onClick: handleSubscribe
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { start: "" }, {
                default: _withCtx(() => [...(_cache[66] || (_cache[66] = [
                  _createTextVNode("mdi-rocket-launch", -1)
                ]))]),
                _: 1
              }),
              _cache[67] || (_cache[67] = _createTextVNode(" 구독 시작하기 ", -1))
            ]),
            _: 1
          }),
          _createVNode(_component_v_btn, {
            color: "white",
            size: "large",
            variant: "outlined",
            class: "cta-btn-secondary"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { start: "" }, {
                default: _withCtx(() => [...(_cache[68] || (_cache[68] = [
                  _createTextVNode("mdi-phone", -1)
                ]))]),
                _: 1
              }),
              _cache[69] || (_cache[69] = _createTextVNode(" 문의하기 ", -1))
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})